///////////////////////////////////////////////////////////////////////////////////////
//                          Copyright (c) 2024 - 2024
//                           Coyote Logistics L.L.C.
//                         All Rights Reserved Worldwide
//
//WARNING:  This program (or document) is unpublished, proprietary
//property of Coyote Logistics L.L.C. and is to be maintained in strict confidence.
//Unauthorized reproduction, distribution or disclosure of this program
//(or document), or any program (or document) derived from it is
//prohibited by State and Federal law, and by local law outside of the U.S.
///////////////////////////////////////////////////////////////////////////////////////

import React from "react";

import messages from "../../helpers/messages";

export const RxoLogoIcon = ({
  className,
  height,
  title = messages.rxo.defaultMessage,
  width
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-labelledby="rxo-logo-icon"
    className={className}
    height={height}
    width={width}
    viewBox="0 0 62 22"
    preserveAspectRatio="xMidYMid meet"
    fill="none"
  >
    <title id="rxo-logo-icon">{title}</title>
    <path
      fill="#000"
      d="M58.822 3.146C56.77 1.117 53.966 0 50.925 0c-3.043 0-5.853 1.117-7.912 3.146-2.06 2.029-3.194 4.796-3.194 7.79 0 6.253 4.775 10.968 11.106 10.968C57.239 21.904 62 17.189 62 10.937c0-2.997-1.129-5.764-3.178-7.79Zm-2.63 7.79c0 3.146-2.264 5.518-5.267 5.518-3.003 0-5.267-2.372-5.267-5.517 0-3.128 2.264-5.487 5.267-5.487 3.003 0 5.267 2.359 5.267 5.487Zm-23.126-.183 7.619 10.815h-6.73l-4.223-6.054-4.254 6.054H18.78l7.587-10.815L19.053.336h6.73l3.949 5.627 3.95-5.627h6.698l-7.314 10.417Zm-18.677 3.165 4.39 7.65h-6.293l-3.705-6.453H5.626v6.453H0V9.878h9.982c1.186 0 2.047-.905 2.047-2.153 0-1.21-.88-2.122-2.047-2.122H0V.336h9.982c4.478 0 7.855 3.177 7.855 7.39 0 2.574-1.283 4.867-3.447 6.192Z"
    />
  </svg>
);

export default RxoLogoIcon;
